import { createSlice } from '@reduxjs/toolkit';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { init_local_generation_price_delete_generation_price_by_diffusion_model_id } from './local_generation_price_delete_generation_price_by_diffusion_model_id';
import { init_local_generation_price_upsert_generation_price_by_hash } from './local_generation_price_upsert_generation_price_by_hash';
import { init_remote_generation_price_get_generation_price_by_hash } from './remote_generation_price_get_generation_price_by_hash';
import { StateGenerationPrice } from './state_generation_price';

const initialState: StateGenerationPrice = {
  generation_prices_by_hashes_map: new Map(),
  generation_prices_by_hash_loading_in_progress_set: new Set(),
};

export const slice_generation_price = createSlice({
  name: ENUM__redux_slice.GENERATION_PRICE,
  initialState,
  reducers: {
    upsert_generation_price_by_hash: init_local_generation_price_upsert_generation_price_by_hash,
    delete_generation_price_by_diffusion_model_id: init_local_generation_price_delete_generation_price_by_diffusion_model_id,
  },

  extraReducers: builder => {
    init_remote_generation_price_get_generation_price_by_hash(builder);

    builder.addCase(LOCAL__global_reset, state => initialState);
  },
});
